import React, { useCallback } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { appActions } from 'store/app';
import Petra from 'assets/images/petra.jpeg';
import { useAptosWalletContext } from 'context/aptosProvider';

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	margin-bottom: 25px;
	align-items: center;

	:hover {
		cursor: pointer;
	}
`;

const Available = styled(Typography)`
	background-color: #4bb543;
	padding: 4px 7px;
	border-radius: 4px;
	color: #fff;
	font-weight: 500;
	font-size: 12px;
`;

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 350,
	backgroundColor: 'white',
	boxShadow: 18,
	clipPath:
		'polygon(18px 0, calc(100% - 18px) 0, 100% 18px, 100% calc(100% - 18px), calc(100% - 18px) 100%, 18px 100%, 0 calc(100% - 18px), 0 18px)',
	p: 4,
	outline: 'none',
	minHeight: 300,
};

const titleBox = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
};

const containerStyle = {
	display: 'flex',
	justifyContent: 'space-between',
};

const WalletConnectModal: React.ComponentType<{}> = () => {
	const dispatch = useDispatch();

	const { isWalletOpen } = useSelector((state: RootState) => state.app);
	const { terms } = useSelector((state: RootState) => state.app);

	const { connect } = useAptosWalletContext();

	const onClose = useCallback(() => {
		dispatch(appActions.openWallet(false));
	}, [dispatch]);

	return (
		<Modal
			open={isWalletOpen}
			onClose={onClose}
			aria-labelledby="custom-modal-title"
			aria-describedby="custom-modal-description"
			disableAutoFocus
			disableEnforceFocus
			style={{ zIndex: 4100 }}
		>
			<Box sx={style}>
				<Box sx={containerStyle}>
					<Box sx={titleBox}>
						<Typography
							id="custom-modal-title"
							variant="subtitle2"
							fontWeight={600}
							alignSelf={'center'}
							color={'#345CF8'}
						>
							Choose your preferred wallet
						</Typography>
						<Box height={20} />

						<Row
							onClick={() => {
								connect();
							}}
						>
							<img
								width={35}
								height={35}
								alt={'petra'}
								src={Petra}
								style={{ borderRadius: 5 }}
							/>
							<Box width={14} />
							<Typography
								fontWeight={'bold'}
								display={'inline'}
								variant={'body2'}
							>
								Petra
							</Typography>
						</Row>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};

export default WalletConnectModal;
